export const fontTypes = ["ttf", "otf", "OTF", "woff", "woff2", "eot"];

export const fontWeight = {
  'thin': 100,
  'hairline': 100,
  'ultrathin': 100,
  'extralight': 200,
  'ultralight': 200,
  'light': 300,
  'book': 350,
  'regular': 400,
  'normal': 400,
  'plain': 400,
  'standard': 400,
  'roman': 400,
  'text': 400,
  'medium': 500,
  'demi': 500,
  'semibold': 600,
  'demibold': 600,
  'extrabold': 700,
  'ultrabold': 700,
  'bold': 700,
  'boldface': 700,
  'extrablack': 800,
  'ultrablack': 800,
  'black': 800,
  'heavy': 900,
  'fat': 900,
  'poster': 900,
  'superbold': 900,
  'extrafine': 100,
  'thinlight': 200,
  'lightmedium': 350,
  'semilight': 350,
  'demilight': 350,
  'normalmedium': 500,
  'extramedium': 500,
  'strong': 700,
  'dark': 800,
  'strongbold': 900,
  'solid': 900,
  'thick': 900,
  'block': 900,
  'compressed': 700,
  'condensed': 700,
  'cond': 700,
  'expanded': 700,
  'extrawide': 700,
  'narrow': 500,
  'compressedlight': 300,
  'condensedlight': 300,
  'condlight': 300,
  'expandedlight': 300,
  'extrawidelight': 300,
  'narrowlight': 300,
  'compressedmedium': 500,
  'condensedmedium': 500,
  'condmedium': 500,
  'expandedmedium': 500,
  'extrawidemedium': 500,
  'narrowmedium': 500,
  'compressedbold': 700,
  'condensedbold': 700,
  'condbold': 700,
  'extracond': 900,
  'expandedbold': 700,
  'extrawidebold': 700,
  'narrowbold': 700,
  'compressedblack': 900,
  'condensedblack': 900,
  'condblack': 900,
  'expandedblack': 900,
  'extrawideblack': 900,
  'narrowblack': 900
};

export const possibleFontWidthKeys = [
  'fontSubfamily',
  'subfamilyName',
  'preferredSubfamily',
  // 'preferredFamily',      
  // 'postScriptName',
  // 'compatibleFullName',
]